import React, { useEffect, useState } from "react";

import "./accordion-with-radio-button.css"
import { Accordion, Card, Collapse } from "react-bootstrap";

import CustomCheckbox from "../custom-checkbox/CustomCheckbox";
import { upperCase } from "lodash";

const AccordionWithRaadioButton = (props) => {
    const { formController, updateValues, checkDoneChange, title, familyFieldDetails, familyMemberName, memberID, isdone, onsetMemberID, disabled } = props
    const [isExpanded, setIsExpanded] = useState(false);
    const [activeIndex, setActiveIndex] = useState([]);

    useEffect(() => {
        if (props.memberData.hasError) {
            setActiveIndex([memberID])
            setIsExpanded(isExpanded ? isExpanded : !isExpanded)
        }
        else {
            setActiveIndex([])
            setIsExpanded(isExpanded ? !isExpanded : isExpanded)
        }
    }, [props.memberData.hasError])

    useEffect(() => {

        if (!isdone) {
            setActiveIndex([])
            setIsExpanded(false)
        }
    }, [isdone])

    useEffect(() => {
        if (checkDoneChange) {
            if (!props.memberData.hasError) {
                setActiveIndex([])
                setIsExpanded(false)
            }
        }
    }, [checkDoneChange])

    const toggleAccordion = (index) => {
        if (!disabled) {
            setIsExpanded(!isExpanded)
            if (activeIndex.includes(index)) {
                // If the accordion is already open, close it
                setActiveIndex(activeIndex.filter(item => item !== index));
            } else {
                // If the accordion is closed, open it
                setActiveIndex([...activeIndex, index]);
            }
        }
    };

    return (
        <Accordion className="p-1 px-2">
            <Accordion.Toggle as={Card.Header} eventKey={memberID.toString()} className=" mb-1 p-3  label_text accordion-content-box" onClick={() => { toggleAccordion(props.memberID) }}>
                <div className={`d-flex  justify-content-between align-items-center ${disabled ? 'accordion-disabled' : ""}` } >
                    <div className="d-flex ">
                        <CustomCheckbox
                            shape='rounded'
                            // title={}
                            containerStyle=''
                            titleStyle='font-weight-bold font-size-16 font-size-lg-18 pl-1 details-title-text text-nowrap'
                            isChecked={props.memberData.fields.is_member_selected.value}
                            onChange={(value) => {
                                updateValues(formController, familyMemberName, 'is_member_selected', value)
                            }}
                            disabled={props.memberData.fields.is_member_selected.disabled}
                            mark='checkmark'
                        />
                        <div className="font-weight-bold text-nowrap">{upperCase(title)}</div>
                    </div>
                    <div className="details-title-text">
                        {isExpanded ?
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style={{ width: " 25px" }}>
                                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
                            </svg>
                            :
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style={{ width: " 25px" }} >
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                            </svg>
                        }
                    </div>
                </div>
            </Accordion.Toggle>

            <Accordion.Collapse eventKey={props.memberID.toString()} in={activeIndex.includes(memberID)}  >
                <Card className='border-0 add-family-member-card mx-md-2 '>
                    <Card.Body className='p-2'>
                        {familyFieldDetails}
                    </Card.Body>
                </Card>
            </Accordion.Collapse>
        </Accordion >
    )
}

export default AccordionWithRaadioButton;